import servicesServices from "../Services/servicesServices";
import { showToast } from "./toast";
import { GET_SERVICES, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE } from "./type";
import { startLoaderAction, stopLoaderAction } from "./updateReducerValue";

export const addServicesAction = (payload) => (dispatch) => {
  dispatch(startLoaderAction());
  return servicesServices.addServices(payload).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return Promise.resolve();
  });
};

export const editServicesAction = (payload) => (dispatch) => {
  dispatch(startLoaderAction());
  return servicesServices.editService(payload).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return Promise.resolve();
  });
};

export const deleteServicesAction = (payload) => (dispatch) => {
  dispatch(startLoaderAction());
  return servicesServices.deleteService(payload).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return Promise.resolve();
  });
};

export const getServicesAction = (page, limit, search) => async (dispatch) => {
  dispatch(startLoaderAction());
  return servicesServices.getServices(page, limit, search).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_SERVICES, payload: resp.data });
    } else {
      //   dispatch(showToast(resp?.data, "error"));
    }
    dispatch(stopLoaderAction());
  });
};
